<!--路线合并的路线  -->
<template>
	<div class="dialogBox">
		<el-dialog title="选择路线" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="800px" :before-close="cancle" top="7vh">
			<span slot="title" class="flex flex-middle">
				<div class="title">选择路线</div>
				<div class="flex ml15">
					<el-input v-model.trim="routeName" class="w190" size="small" placeholder="路线名称" maxlength="16"
						clearable>
					</el-input>
					<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearchRoute" alt="">
				</div>
			</span>
			<el-table class="mt10" ref="multipleTable" v-el-table-infinite-scroll="tableLoad" :data="tableData"
				height="400" :header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
				@cell-click="handleCellClick" border style="width: 100%">
				<el-table-column width="60" label="选择" align="center">
					<template slot-scope="scope">
						<el-radio v-model="selecteId" :label="scope.row.routeId"></el-radio>
					</template>
				</el-table-column>
				<el-table-column prop="routeCode" label="路线编号" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="licensePlate" label="车辆" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="licensePlate" label="配送周期" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-select
							v-model="scope.row.deliveryCycle"
							class="w100"
							size="small"
							v-if="scope.row.deliveryCycleShow"
						>
							<el-option
								v-for="(item,i) in weeklist"
								:label="item.label"
								:value="item.value"
								:key="i"
							></el-option>
						</el-select>
						<span v-else>{{ deliveryCycle[scope.row.deliveryCycle] }}</span>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">确 定</el-button>
			</span>
		</el-dialog>
		<tourEdit ref="tourEdit" v-on="$listeners"></tourEdit>
	</div>
</template>

<script>
	import TourEdit from './tour-edit'
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		components: {
			TourEdit
		},
		data() {
			return {
				dialogVisible: false,
				routeName: "",
				tableData: [],
				titles: [],
				pageNo: 1,
				pageSize: 20,
				totalPage: 0,
				deliveryCycle:{
					1: '周一',
					2: '周二',
					3: '周三',
					4: '周四',
					5: '周五',
					6: '周六',
					0: '周日'
				},
				weeklist: [
				{
					value: "1",
					label: "周一"
				},
				{
					value: "2",
					label: "周二"
				},
				{
					value: "3",
					label: "周三"
				},
				{
					value: "4",
					label: "周四"
				},
				{
					value: "5",
					label: "周五"
				},
				{
					value: "6",
					label: "周六"
				},
				{
					value: "0",
					label: "周日"
				}
			],
				multipleSelection: [],
				selecteId: '',
				selectList: [],
				infiniteFlag: false
			}
		},
		created() {

		},
		methods: {
			init(selectList, newFlag) {
				this.dialogVisible = true;
				this.infiniteFlag = false
				this.$nextTick(() => {
					this.routeName = "";
					this.pageNo = 1;
					this.getRouteList();
					this.selecteId = "";
				})
			},
			//  获取列表
			getRouteList(type) {
				if(this.infiniteFlag) {
					return
				}
				let that = this;
				that.$request.post(
						"routeInfoList",
						true, {
							pageNo: that.pageNo,
							pageSize: that.pageSize,
							routeName: that.routeName,
							routeStatus: "Y"
						}
					)
					.then((res) => {
						if(res.data) {
							that.infiniteFlag = res.data.totalPage <= that.pageNo;
						}
						if (res) {
							// deliveryCycleShow deliveryCycle=9的时候配送周期显示下拉框
							for (const item of res.data.list) {
								if(item.deliveryCycle == 9) {
									item.deliveryCycleShow = true;
									item.deliveryCycle = '1';
								}else {
									item.deliveryCycleShow = false;
								}
							}
							if(type == 'scroll') {
								that.tableData = that.tableData.concat(res.data.list);
							}else {
								that.tableData = res.data.list;
							}
						}
					})
			},
			// 表格滚动加载
			tableLoad: debounce(function () {
				this.pageNo++;
				this.getRouteList('scroll');
			}, 100, true),
			// 当前页切换
			handleCurrentChange(val) {
				this.pageNo = val;
				this.getRouteList();
			},
			// 搜索
			handleSearchRoute() {
				if(this.tableData.length > 0){
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
				}

				this.pageNo = 1;
				this.infiniteFlag = false;
				this.$nextTick(() => {
					this.getRouteList();
				})
			},
			handleCellClick(row, column, cell, event) {
				this.selecteId = row.routeId;
			},
			// 保存
			submitForm: debounce(function () {
				let deliveryCycle = '';
				for (const iterator of this.tableData) {
					if(iterator.routeId == this.selecteId) {
						deliveryCycle = iterator.deliveryCycle
					}
				}
				if(this.selecteId == '') {
					this.$message.error('请选择路线');
					return
				}
				let that = this;
				that.$request.post(
						"roundPlanAdd",
						true, {
							routeId: that.selecteId,
							deliveryCycle: deliveryCycle
						}
					)
					.then((res) => {
						if (res) {
							if(res.data == null) {
								that.$message.error('路线中不存在此配送周期客商，无法生成计划。');
							}else {
								that.dialogVisible = false;
								that.$refs.tourEdit.init(res.data);
							}
						}
					})

			}, 1000, true),
			// 取消
			cancle() {
				this.dialogVisible = false;
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 0px 10px;
		}

		/deep/ .el-radio .el-radio__label {
			display: none;
		}
	}

	.el-dialog__body {
		height: 500px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

	.w100 {
		width: 100px;
	}
</style>
